import { getJsonAsync } from './fetchConfig';

export const getOrganization = (id) => getJsonAsync(`organizations/${id}`);
